<template>
    <Transition name="slide" mode="out-in">
        <component v-if="currentView" :is="currentView" :key="currentIndex" />
    </Transition>
</template>

<script lang="ts" setup>
import { ref, computed, onMounted, onBeforeUnmount, watch } from 'vue'
import ElectricityConsumptionView from '@/views/ElectricityConsumptionView.vue'
import PhotovoltaicProductionView from '@/views/PhotovoltaicProductionView.vue'
import WaterManagementView from '@/views/WaterManagementView.vue'
import WasteManagementView from '@/views/WasteManagementView.vue'
import { useDataStore } from '@/stores/store_data'

const store = useDataStore()

const views = [
    ElectricityConsumptionView,
    PhotovoltaicProductionView,
    WaterManagementView,
    WasteManagementView
]

const currentIndex = ref(0)
const currentView = computed(() => views[currentIndex.value])

let interval: ReturnType<typeof setInterval>

watch(currentIndex, (newIndex) => {
    store.setCurrentViewIndex(newIndex)
}, { immediate: true })

onMounted(() => {
    interval = setInterval(() => {
        currentIndex.value = (currentIndex.value + 1) % views.length
    }, 30000)
})

onBeforeUnmount(() => {
    clearInterval(interval)
})
</script>

<style scoped>
.slide-enter-from {
    transform: translateX(100%);
    opacity: 0;
}

.slide-enter-to {
    transform: translateX(0);
    opacity: 1;
}

.slide-leave-from {
    transform: translateX(0);
    opacity: 1;
}

.slide-leave-to {
    transform: translateX(-100%);
    opacity: 0;
}

.slide-enter-active,
.slide-leave-active {
    transition: all 0.5s ease;
}
</style>
